import { foundationRadioTemplate } from '@genesislcap/foundation-ui';
export const zeroRadioTemplate = (context, definition) => foundationRadioTemplate(context, definition);
